import React from 'react';

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { cutText } from 'utils';

import { ReactComponent as ArrowIcon } from 'pages/Teachers/AssignmentsList/assets/arrow.svg';
import { ReactComponent as StandardIcon } from 'pages/Teachers/AssignmentsList/assets/standards.svg';

import styles from './styles.module.scss';

const AssignmentTable = ({ isMath, onRowNavigation, data, dataIsLoading }) => {
  return (
    <>
      <TableContainer
        component={Paper}
        className={styles.tableCard}
        elevation={0}
      >
        <Table aria-label="Section assignments ledger grid">
          <TableHead className={styles.tableHead}>
            <TableRow className={styles.tableHeaderRow}>
              <TableCell className={styles.gridHeaderCellText}>
                Assignment Name
              </TableCell>
              <TableCell className={styles.gridHeaderCellText}>
                Due Date
              </TableCell>
              <TableCell className={styles.gridHeaderCellText}>
                Standards
              </TableCell>
              <TableCell className={styles.gridHeaderCellText}>
                Uploads Status
              </TableCell>
              {isMath && (
                <TableCell className={styles.gridHeaderCellText}>
                  Mastery Level
                </TableCell>
              )}
              <TableCell className={styles.gridHeaderCellText} align="right" />
            </TableRow>
          </TableHead>
          <TableBody>
            {!dataIsLoading && data?.length === 0 && (
              <TableRow className={styles.tableBodyDataRow}>
                <TableCell
                  colSpan={isMath ? 6 : 5}
                  className={styles.cellTextAssignmentTitle}
                >
                  No assignments found.
                </TableCell>
              </TableRow>
            )}
            {!dataIsLoading &&
              data?.map((assignment) => (
                <TableRow
                  key={assignment.id}
                  className={styles.tableBodyDataRow}
                  onClick={() =>
                    onRowNavigation({ assignmentId: assignment.id })
                  }
                >
                  <TableCell className={styles.cellTextAssignmentTitle}>
                    {cutText({ text: assignment.name, char: 25 })}
                  </TableCell>

                  <TableCell className={styles.cellTextTargetDeadline}>
                    {new Date(assignment.due_at).toLocaleDateString('en-US', {
                      timeZone: 'UTC'
                    })}
                  </TableCell>

                  <TableCell className={styles.cellContainerStandardsChips}>
                    <div className={styles.standardsFlexContainer}>
                      {assignment.standards.map((badge, standardIndex) => (
                        <div
                          key={`${assignment.id}-${standardIndex}`}
                          className={styles.academicTagBadge}
                        >
                          <span className={styles.capDecorativeIcon}>
                            <StandardIcon />
                          </span>
                          <span>{badge}</span>
                        </div>
                      ))}
                    </div>
                  </TableCell>

                  <TableCell className={styles.cellTextUploadProgressValue}>
                    {`${assignment.upload_status}%`}
                  </TableCell>

                  {isMath && (
                    <TableCell className={styles.cellInlineMasteryVisualChart}>
                      <div className={styles.rowInlineMicroProgressContainer}>
                        <div
                          className={styles.microProgressInterveneSegment}
                          style={{
                            width: `${assignment.intervene_percentage}%`
                          }}
                        />
                        <div
                          className={styles.microProgressSupportSegment}
                          style={{ width: `${assignment.support_percentage}%` }}
                        />
                        <div
                          className={styles.microProgressCelebrateSegment}
                          style={{
                            width: `${assignment.celebrate_percentage}%`
                          }}
                        />
                      </div>
                    </TableCell>
                  )}

                  <TableCell
                    align="right"
                    className={styles.cellActionArrowNavigationLink}
                  >
                    <ArrowIcon />
                  </TableCell>
                </TableRow>
              ))}
            {dataIsLoading && (
              <>
                <TableRow className={styles.tableBodyDataRow}>
                  <TableCell
                    colSpan={isMath ? 6 : 5}
                    className={styles.cellTextAssignmentTitle}
                  >
                    <Skeleton animation="wave" width="100%" />
                  </TableCell>
                </TableRow>
                <TableRow className={styles.tableBodyDataRow}>
                  <TableCell
                    colSpan={isMath ? 6 : 5}
                    className={styles.cellTextAssignmentTitle}
                  >
                    <Skeleton animation="wave" />
                  </TableCell>
                </TableRow>
                <TableRow className={styles.tableBodyDataRow}>
                  <TableCell
                    colSpan={isMath ? 6 : 5}
                    className={styles.cellTextAssignmentTitle}
                  >
                    <Skeleton animation="wave" />
                  </TableCell>
                </TableRow>
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default AssignmentTable;
